export default {
    ADMIN: "Admin",
    USER: "User",
}